import { instance } from '../app/instance';

/**
 * Get payment settings
 * GET /api/admin/payment/settings
 */
export const getPaymentSettings = async () => {
  const response = await instance.get('/payment/settings');
  return response.data;
};

/**
 * Update payment settings
 * PATCH /api/admin/payment/settings
 */
export const updatePaymentSettings = async (updates) => {
  const response = await instance.patch('/payment/settings', updates);
  return response.data;
};

/**
 * Test RozetkaPay connection
 * POST /api/admin/payment/settings/test-connection
 */
export const testRozetkaPayConnection = async () => {
  const response = await instance.post('/payment/settings/test-connection');
  return response.data;
};
